// Selectors
export const getResultIds = state => state.results.idList;
export const getNextLink = state => state.nextLink;
export const getIsLoading = state => state.isLoading;
export const getQuery = state => state.query;
export const getSearchFilterId = state => state.filterId;
export const getSearchAgendaId = state => state.agendaId;
export const getAfoLink = state => state.afoLink;
